var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "mail-integration" } },
    [
      _c("div", { staticClass: "email-service-status" }, [
        _c("div", { staticClass: "service-card" }, [
          _c("div", { staticClass: "service-header" }, [
            _c("div", { staticClass: "service-title" }, [
              _vm._v("E-posta Sağlayıcısı"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "service-status",
                class: { "status-active": _vm.domainIsCreated },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.domainIsCreated ? "Bağlandı" : "Bağlı Değil") +
                    "\n                "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "service-content" }, [
            _c("div", { staticClass: "provider-logo" }, [
              _c("img", { attrs: { src: _vm.logoUrl, alt: "Provider Logo" } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "provider-info" }, [
              _c("div", { staticClass: "provider-name" }, [
                _vm._v("Mail Alanınızı Aktifleştirin"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "domain-name" }, [
                _vm._v(_vm._s(_vm.emailDomain)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "action-area" },
              [
                !_vm.domainIsCreated && _vm.emailBtnEnabled
                  ? _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.createDomain },
                      },
                      [
                        _vm._v(
                          "\n                        Bağlan\n                    "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.emailBtnEnabled
                  ? _c("SupsisButton", { attrs: { disabled: true } }, [
                      _vm._v(" Yükleniyor..."),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.domainIsCreated && _vm.emailBtnEnabled
                  ? _c("div", { staticClass: "domain-connected" }, [
                      _c("span", { staticClass: "material-icons check-icon" }, [
                        _vm._v("check_circle"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Doğrulandı")]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.domainIsCreated
        ? _c("div", { staticClass: "mail-dashboard" }, [
            _c("div", { staticClass: "dashboard-header" }, [
              _c("div", { staticClass: "dashboard-title" }, [
                _vm._v("Mail Yönetimi"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dashboard-tabs" }, [
                _c("div", { staticClass: "tab-count" }, [
                  _vm._v(_vm._s(_vm.allowedMailAddresses.length)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mail-section" }, [
              _c(
                "div",
                { staticClass: "section-header" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm.domainIsCreated
                    ? _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$feature.beforeCreateUserMail(
                                _vm.showModel
                              )
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("add"),
                          ]),
                          _vm._v(
                            "\n                    Yeni Adres Ekle\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mail-groups" },
                [
                  Object.keys(_vm.groupedUserMails).length === 0
                    ? [_vm._m(1)]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.groupedUserMails, function (group, groupId) {
                    return _c(
                      "div",
                      {
                        key: "user-" + groupId,
                        staticClass: "mail-group-container",
                      },
                      [
                        _c("div", { staticClass: "mail-group" }, [
                          _c("div", { staticClass: "group-header" }, [
                            _c("div", { staticClass: "group-title" }, [
                              _c(
                                "span",
                                { staticClass: "material-icons user-icon" },
                                [_vm._v("account_circle")]
                              ),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    typeof group === "object"
                                      ? group.name
                                      : "Bilinmeyen Kullanıcı"
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "group-badges" }, [
                              _c("span", { staticClass: "badge mail-count" }, [
                                _vm._v(
                                  " " +
                                    _vm._s((group.mails || []).length) +
                                    " Mail Adresi "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mail-items" },
                            _vm._l(group.mails || [], function (mail) {
                              return _c(
                                "div",
                                { key: mail._id, staticClass: "mail-item" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "mail-icon" },
                                    [_c("MailIcon")],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "mail-info",
                                      on: {
                                        click: function ($event) {
                                          return _vm.mailDetail(false, mail._id)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "mail-address" },
                                        [_vm._v(_vm._s(mail.mail))]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mail-meta" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "mail-status",
                                            class: {
                                              verified: mail.isVerified,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  mail.isVerified
                                                    ? "Doğrulandı"
                                                    : "Doğrulanmadı"
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "mail-type" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                mail.isForward
                                                  ? "Yönlendirme Mail"
                                                  : "Standart Mail"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mail-actions" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "delete-button",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.deleteMailAddress(mail)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "material-icons" },
                                          [_vm._v("delete")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mail-section" }, [
              _c(
                "div",
                { staticClass: "section-header" },
                [
                  _vm._m(2),
                  _vm._v(" "),
                  _vm.domainIsCreated
                    ? _c(
                        "SupsisButton",
                        {
                          attrs: {
                            primary: "",
                            disabled: !_vm.isAllowCreateDepartment(),
                          },
                          on: {
                            click: function ($event) {
                              _vm.isAllowCreateDepartment() &&
                                _vm.showModel(true)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("add"),
                          ]),
                          _vm._v(
                            "\n                    Yeni Adres Ekle\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mail-groups" },
                [
                  Object.keys(_vm.groupedDepartmentMails).length === 0
                    ? [_vm._m(3)]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.groupedDepartmentMails, function (group, groupId) {
                    return _c(
                      "div",
                      {
                        key: "dept-" + groupId,
                        staticClass: "mail-group-container",
                      },
                      [
                        _c("div", { staticClass: "mail-group" }, [
                          _c("div", { staticClass: "group-header" }, [
                            _c("div", { staticClass: "group-title" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "material-icons department-icon",
                                },
                                [_vm._v("apartment")]
                              ),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(group.name) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "group-badges" }, [
                              _c("span", { staticClass: "badge mail-count" }, [
                                _vm._v(
                                  " " +
                                    _vm._s((group.mails || []).length) +
                                    " Mail Adresi "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mail-items" },
                            _vm._l(group.mails || [], function (mail) {
                              return _c(
                                "div",
                                { key: mail._id, staticClass: "mail-item" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "mail-icon" },
                                    [_c("MailIcon")],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "mail-info",
                                      on: {
                                        click: function ($event) {
                                          return _vm.mailDetail(true, mail)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "mail-address" },
                                        [_vm._v(_vm._s(mail.mail))]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mail-meta" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "mail-status",
                                            class: {
                                              verified: mail.isVerified,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  mail.isVerified
                                                    ? "Doğrulandı"
                                                    : "Doğrulanmadı"
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "mail-type" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                mail.isForward
                                                  ? "Yönlendirme Mail"
                                                  : "Standart Mail"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mail-actions" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "delete-button",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.deleteMailAddress(mail)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "material-icons" },
                                          [_vm._v("delete")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.domainIsCreated
        ? _c("div", { staticClass: "setup-required" }, [_vm._m(4)])
        : _vm._e(),
      _vm._v(" "),
      _vm.isNewUserMail || _vm.isNewDepartment
        ? _c(
            "Modal2",
            {
              attrs: {
                "class-name": "mail-create-modal",
                title: _vm.isNewDepartment
                  ? "Departman Maili Oluştur"
                  : "Kullanıcı Maili Oluştur",
                showFooter: false,
                showTitle: false,
              },
              on: {
                cancel: function ($event) {
                  return _vm.handleCancel()
                },
              },
            },
            [
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "modal-custom-header" }, [
                  _c("div", { staticClass: "header-icon" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(
                        _vm._s(_vm.isNewDepartment ? "business" : "person")
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "header-title" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.isNewDepartment
                            ? "Departman Maili Oluştur"
                            : "Kullanıcı Maili Oluştur"
                        ) +
                        "\n                "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-custom-content" }, [
                  !!_vm.isNewDepartment
                    ? _c(
                        "div",
                        { staticClass: "form-item" },
                        [
                          _c("label", { attrs: { for: "dept-select" } }, [
                            _vm._v("Konu Seçin"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { id: "dept-select" },
                              model: {
                                value: _vm.selectedDepartmentId,
                                callback: function ($$v) {
                                  _vm.selectedDepartmentId = $$v
                                },
                                expression: "selectedDepartmentId",
                              },
                            },
                            _vm._l(
                              _vm.getSelectDepartmentList(),
                              function (subject) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: subject._id,
                                    attrs: { value: subject._id },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          subject.languageContent.tr.name
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-item mail-field-container" }, [
                    _c("label", { attrs: { for: "mail-name" } }, [
                      _vm._v("Mail Adresi"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "mail-input-container",
                        class: { "input-error": _vm.isMailError },
                      },
                      [
                        _c("a-input", {
                          staticClass: "mail-name-input",
                          attrs: {
                            id: "mail-name",
                            "aria-disabled":
                              Object.keys(_vm.groupedUserMails).length !== 0 &&
                              !_vm.isNewDepartment,
                            placeholder: "Mail ön adını giriniz",
                          },
                          on: { input: _vm.checkMailValidity },
                          model: {
                            value: _vm.emailName,
                            callback: function ($$v) {
                              _vm.emailName = $$v
                            },
                            expression: "emailName",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "mail-domain" }, [
                          _vm._v("@" + _vm._s(_vm.emailDomain)),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isMailError
                      ? _c("div", { staticClass: "input-error-message" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.mailErrorMessage) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.emailName.length > 0 && !_vm.isMailError
                      ? _c("div", { staticClass: "input-helper" }, [
                          _c("span", { staticClass: "full-mail" }, [
                            _vm._v(
                              _vm._s(_vm.emailName) +
                                "@" +
                                _vm._s(_vm.emailDomain)
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-notice" }, [
                    _c("span", { staticClass: "material-icons notice-icon" }, [
                      _vm._v("info"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "notice-text" }, [
                      _vm._v(
                        "\n                        Mail adresi özel karakter içeremez. Türkçe karakter ve boşluk kullanmayınız.\n                    "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-custom-footer" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        staticClass: "cancel-btn",
                        on: { click: _vm.handleCancel },
                      },
                      [_vm._v("İptal")]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        staticClass: "create-btn",
                        attrs: {
                          primary: "",
                          disabled:
                            !_vm.domainIsCreated ||
                            !_vm.emailBtnEnabled ||
                            _vm.isMailError ||
                            _vm.isMailExists ||
                            _vm.emailName.length === 0,
                        },
                        on: {
                          click: function ($event) {
                            !!_vm.isNewDepartment
                              ? _vm.createDepartment()
                              : _vm.createUserEmail()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    Oluştur\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("span", { staticClass: "material-icons section-icon" }, [
        _vm._v("person"),
      ]),
      _vm._v(
        "\n                    Kullanıcı E-posta Adresleri\n                "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-state" }, [
      _c("span", { staticClass: "material-icons empty-icon" }, [
        _vm._v("email"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "empty-text" }, [
        _vm._v("Hiç mail adresi bulunamadı."),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "empty-description" }, [
        _vm._v(
          "\n                            Yeni bir mail adresi oluşturmak için ekle butonuna tıklayınız.\n                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("span", { staticClass: "material-icons section-icon" }, [
        _vm._v("business"),
      ]),
      _vm._v(
        "\n                    Departman Mail Adresleri\n                "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-state" }, [
      _c("span", { staticClass: "material-icons empty-icon" }, [
        _vm._v("business_center"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "empty-text" }, [
        _vm._v("Hiç mail adresi bulunamadı."),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "empty-description" }, [
        _vm._v(
          "\n                            Yeni bir mail adresi oluşturmak için ekle butonuna tıklayınız.\n                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "setup-content" }, [
      _c("span", { staticClass: "material-icons setup-icon" }, [
        _vm._v("email"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "setup-title" }, [
        _vm._v("Mail entegrasyonu kurulumu gerekli"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "setup-description" }, [
        _vm._v(
          "\n                Mail adreslerini yönetmek için önce domain bağlantısını yapmalısınız.\n            "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }